import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

// url/params: chiamata DELETE; queryKey: elenco da ricaricare
export const ConfirmDelete = ({ title, description, url, params, queryKey, success, testid }) => {
  const qc = useQueryClient();
  const del = useMutation({
    mutationFn: async () => (await api.delete(url, { params })).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey }); toast.success(success); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore durante l'eliminazione"),
  });
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-rose-400" onClick={(e) => e.stopPropagation()} data-testid={testid}>
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description} L'operazione non si può annullare.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`}>Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={() => del.mutate()} className="bg-rose-600 hover:bg-rose-700" data-testid={`${testid}-confirm`}>Elimina</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
